module.exports = __webpack_public_path__ + "static/media/PDMS Research Projects.ddee04f5.csv";